import { render, staticRenderFns } from "./ptTableRowLotto.vue?vue&type=template&id=ddc8d0c0&lang=pug&"
import script from "./ptTableRowLotto.vue?vue&type=script&lang=js&"
export * from "./ptTableRowLotto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports